import React from "react";
import Picture from "./Picture";
import { supplierImg } from "../lib/supplierImages";

const pairs = [
  {
    id: "built-in",
    heading: "Built-in cabinetry",
    before: {
      image: supplierImg("westborough-home-theater-before-1"),
      alt: "Built-in cabinetry before the television installation in Westborough, MA",
    },
    after: {
      image: supplierImg("westborough-home-theater-after-1"),
      alt: "Television installed in built-in cabinetry in Westborough, MA",
    },
  },
  {
    id: "fireplace",
    heading: "Fireplace wall",
    before: {
      image: supplierImg("westborough-home-theater-before-2"),
      alt: "Fireplace wall before the television installation in Westborough, MA",
    },
    after: {
      image: supplierImg("westborough-home-theater-after-2"),
      alt: "Television mounted above the fireplace in Westborough, MA",
    },
  },
];

const WestboroughBeforeAfter: React.FC = () => (
  <section className="section section-light" data-testid="westborough-before-after">
    <div className="container">
      <span className="eyebrow">Westborough project</span>
      <h2>Before and after.</h2>
      <div className="westborough-before-after-pairs">
        {pairs.map((pair) => (
          <article className="westborough-before-after-pair" key={pair.id}>
            <h3>{pair.heading}</h3>
            <div className="westborough-before-after-photos">
              <figure>
                <Picture
                  src={pair.before.image}
                  alt={pair.before.alt}
                  width={1200}
                  height={900}
                  sizes="(max-width: 520px) 100vw, (max-width: 900px) 50vw, 300px"
                  responsiveVariantByViewport
                />
                <figcaption>Before</figcaption>
              </figure>
              <figure>
                <Picture
                  src={pair.after.image}
                  alt={pair.after.alt}
                  width={1200}
                  height={900}
                  sizes="(max-width: 520px) 100vw, (max-width: 900px) 50vw, 300px"
                  responsiveVariantByViewport
                />
                <figcaption>After</figcaption>
              </figure>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default WestboroughBeforeAfter;
